import React from 'react';
import { useContext } from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { AuthContext } from '../../Context/AuthProvider/AuthProvider';

const Resume = () => {
    const { user } = useContext(AuthContext);

    const [resume, setResume] = useState([]);

    useEffect(() => {
        fetch(`https://cv-builder-application-server.vercel.app/all-resume/${user?.email}`)
            .then(res => res.json())
            .then(data => setResume(data))
    }, [user?.email])
    console.log(resume)

    const { name, email, phone, title, github, linkedin, portfolio, aboutme, experties, comfortable, frameworks, toolsandsoftware, language1, language2, languageexpert1, languageexpert2, projects } = resume;


    return (
        <div className='bg-gray-800 py-20'>
            <div className='container mx-auto xl:px-32'>

                {
                    resume.length === 0 ? <h1 className='text-white text-2xl font-semibold text-center'>You do not create any resume. Please <Link to='/create-resume' className='text-blue-800 underline'>Create Resume</Link> First then visit this page. Thanks</h1> : <div className=' bg-white  p-16'>


                        <div className='flex justify-between'>
                            <div>
                                <h1 className='text-5xl font-bold'>{name}</h1>
                                <h3 className='text-3xl font-bold 3xl mt-2'>{title}</h3>
                            </div>
                            <div className='text-end'>
                                <p className='text-2xl'>Phone: {phone}</p>
                                <p className='text-2xl'>Email: {email}</p>
                                <a className='text-2xl text-[#004AAD] underline' target="_blank" rel="noreferrer" href={github}>GitHub</a><br />
                                <a className='text-2xl text-[#004AAD] underline' target="_blank" rel="noreferrer" href={linkedin}>Linkedin</a><br />
                                <a className='text-2xl text-[#004AAD] underline' target="_blank" rel="noreferrer" href={portfolio}>Portfolio</a>
                            </div>
                        </div>


                        <div className="divider"><span className='text-3xl font-bold 3xl'>About Me</span> </div>


                        <div className='py-5'>
                            <p className='text-2xl'>{aboutme}</p>
                        </div>


                        <div className="divider"><span className='text-3xl font-bold 3xl'>My Skills</span> </div>


                        <div className='py-5'>
                            <h3 className='text-2xl '><span className='font-bold 3xl'>* Experties:</span> {experties}</h3>
                            <h3 className='text-2xl '><span className='font-bold 3xl'>* Comfortable :</span> {comfortable} </h3>
                            <h3 className='text-2xl '><span className='font-bold 3xl'>* Frameworks :</span> {frameworks}</h3>
                            <h3 className='text-2xl '><span className='font-bold 3xl'>* Tools & Software:</span> {toolsandsoftware}</h3>
                        </div>

                        <div className="divider"><span className='text-3xl font-bold 3xl'>My Projects</span> </div>



                        <div className='py-5'>

                            {
                                projects?.map(project => <div className='my-8'>
                                    <h3 className='text-2xl '><span className='font-bold 3xl'>{project?.projectName}</span>  ( {project?.projectSpeciality} ) </h3>
                                    <div className='ml-20 my-4'>
                                        <p className='text-2xl'>* {project?.bulletepoint1}</p>
                                        <p className='text-2xl'>* {project?.bulletepoint2}</p>
                                        <p className='text-2xl'>* {project?.bulletepoint3}</p>
                                    </div>
                                    <div className='flex justify-center'>
                                        <a className='text-2xl text-[#004AAD] underline' target="_blank" rel="noreferrer" href={project?.livelink}>Live Site Link</a>
                                        <div className="divider divider-horizontal"></div>
                                        <a className='text-2xl text-[#004AAD] underline' target="_blank" rel="noreferrer" href={project?.clientRepo}>Github ( Client Repo )</a>
                                        <div className="divider divider-horizontal"></div>
                                        <a className='text-2xl text-[#004AAD] underline' target="_blank" rel="noreferrer" href={project?.serverRepo}>Github (Server Repo)</a>
                                    </div>
                                </div>)
                            }


                        </div>


                        <div className="divider"><span className='text-3xl font-bold 3xl my-5'>Languages</span> </div>

                        <div>
                            <h3 className='text-2xl '><span className='font-bold 3xl'>{language1} -</span> {languageexpert1}</h3>
                            <h3 className='text-2xl '><span className='font-bold 3xl'>{language2} -</span> {languageexpert2}</h3>

                        </div>




                    </div>
                }


            </div>
        </div>
    );
};

export default Resume;